// extracted by mini-css-extract-plugin
module.exports = {"radioInputRow":"m_p8","radioInputColumn":"m_p9","inputOptionRow":"m_p1","inputOptionColumn":"m_p2"};